import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Color } from '@models/authentication/enums/color.enum';
import { AppColor } from '@models/commons/app-color.model';

import { AppUtils } from '@app/shared/utils/app.utils';

@Component({
  selector: 'app-color-picker',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ColorPickerComponent,
      multi: true
    }
  ],
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent implements ControlValueAccessor {
  readonly appColors = AppUtils.appColors;

  @Input() set color(color: Color) {
    this.pickedColor = color;
  }

  get color(): Color {
    return this.pickedColor;
  }

  @Input() formControl: FormControl;
  @Input() readonly: boolean;

  @Output() colorPicked = new EventEmitter<Color>();

  private onChangeCallback: (_: any) => {};
  private onTouchedCallback: (_: any) => {};

  private pickedColor: Color;

  constructor() {
  }

  writeValue(color: Color) {
    this.color = color;
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  onPickColor(appColor: AppColor) {
    if (this.formControl) {
      this.formControl.setValue(appColor.color);
    }
    if (this.onChangeCallback) {
      this.onChangeCallback(appColor.color);
    }
    if (this.onTouchedCallback) {
      this.onTouchedCallback(appColor.color);
    }
    this.colorPicked.emit(appColor.color);
  }
}
